import { departments } from "./data.js";
import { DATA_TA } from "./dataTa.js";
import { isDirectPaymentUrl } from "./deptHelpers.js";

export const SITE_URL = "https://www.indiafees.com";

const CITY_CORP_PORTALS = {
  salem: "https://salemcorporation.gov.in/",
  tirunelveli: "https://tirunelvelicorporation.in/",
  tiruppur: "https://www.tiruppurcorporation.gov.in/",
  vellore: "https://www.vellorecorporation.gov.in/",
  thoothukudi: "https://www.thoothukudicorporation.gov.in/",
  dindigul: "https://www.dindigulcorporation.gov.in/",
  thanjavur: "https://www.thanjavurcorporation.gov.in/",
  nagercoil: "https://www.nagercoilcorporation.in/",
  cuddalore: "https://www.cuddalorecorporation.gov.in/",
  karur: "https://www.karurcorporation.gov.in/",
  kumbakonam: "https://www.kumbakonamcorporation.gov.in/",
  erode: "https://erodecorp.tn.gov.in/",
};

function cityPaymentEligible(payment) {
  return isDirectPaymentUrl(payment.payUrl || payment.url);
}

function corpFallbackEntry(city) {
  const dept = departments.find((d) => d.id === 2);
  const pay = dept?.payments.find((p) => p.name === "TN urban municipal tax");
  const portalUrl = CITY_CORP_PORTALS[city.slug];
  if (!dept || !pay || !portalUrl) return null;
  const index = dept.payments.indexOf(pay);
  return {
    dept,
    payment: { ...pay, portalUrl },
    index,
    slug: paymentSlug(dept.id, index, pay.name),
    ta: DATA_TA[dept.id]?.payments?.[index],
  };
}
function corpMatch(...patterns) {
  const re = new RegExp(patterns.join("|"), "i");
  return (p, d) => re.test(`${p.name} ${p.desc} ${p.url} ${d?.dept || ""}`);
}

export const CITIES = [
  {
    slug: "chennai",
    name: "Chennai",
    nameTa: "சென்னை",
    corp: true,
    featuredStar: true,
    desc: "Greater Chennai Corporation — electricity, property tax, water bill, CMDA and official TN payment links.",
    descTa: "சென்னை மாநகராட்சி — மின்சாரம், சொத்து வரி, குடிநீர், CMDA மற்றும் அதிகாரப்பூர்வ கட்டண இணைப்புகள்.",
    match: corpMatch("chennai", "cmwssb", "gcc", "cmda", "greater chennai"),
  },
  {
    slug: "coimbatore",
    name: "Coimbatore",
    nameTa: "கோயம்புத்தூர்",
    corp: true,
    desc: "Coimbatore Municipal Corporation — property tax, water tax and official Tamil Nadu payment portals.",
    descTa: "கோயம்புத்தூர் மாநகராட்சி — சொத்து வரி, குடிநீர் வரி மற்றும் அதிகாரப்பூர்வ கட்டண இணைப்புகள்.",
    match: corpMatch("coimbatore", "ccmc"),
  },
  {
    slug: "madurai",
    name: "Madurai",
    nameTa: "மதுரை",
    corp: true,
    desc: "Madurai Municipal Corporation property tax and Tamil Nadu government payment links.",
    descTa: "மதுரை மாநகராட்சி சொத்து வரி மற்றும் தமிழ்நாடு அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("madurai"),
  },
  {
    slug: "trichy",
    name: "Tiruchirappalli",
    nameTa: "திருச்சிராப்பள்ளி",
    corp: true,
    desc: "Tiruchirappalli Municipal Corporation — property tax and official TN payment portals.",
    descTa: "திருச்சிராப்பள்ளி மாநகராட்சி — சொத்து வரி மற்றும் அதிகாரப்பூர்வ கட்டண இணைப்புகள்.",
    match: corpMatch("trichy", "tiruchirappalli", "tiruchi"),
  },
  {
    slug: "salem",
    name: "Salem",
    nameTa: "சேலம்",
    corp: true,
    desc: "Salem Municipal Corporation — property tax, utilities and official TN government payment links.",
    descTa: "சேலம் மாநகராட்சி — சொத்து வரி, பயன்பாட்டு கட்டணம் மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("salem"),
  },
  {
    slug: "tirunelveli",
    name: "Tirunelveli",
    nameTa: "திருநெல்வேலி",
    corp: true,
    desc: "Tirunelveli Municipal Corporation — official Tamil Nadu online payment links.",
    descTa: "திருநெல்வேலி மாநகராட்சி — அதிகாரப்பூர்வ ஆன்லைன் கட்டண இணைப்புகள்.",
    match: corpMatch("tirunelveli", "nellai"),
  },
  {
    slug: "tiruppur",
    name: "Tiruppur",
    nameTa: "திருப்பூர்",
    corp: true,
    desc: "Tiruppur Municipal Corporation — property tax and TN government payment portals.",
    descTa: "திருப்பூர் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("tiruppur", "tirupur"),
  },
  {
    slug: "erode",
    name: "Erode",
    nameTa: "ஈரோடு",
    corp: true,
    desc: "Erode Municipal Corporation — property tax, water tax and government fee payment links.",
    descTa: "ஈரோடு மாநகராட்சி — சொத்து வரி, குடிநீர் வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("erode"),
  },
  {
    slug: "vellore",
    name: "Vellore",
    nameTa: "வேலூர்",
    corp: true,
    desc: "Vellore Municipal Corporation — property tax and Tamil Nadu government payment portals.",
    descTa: "வேலூர் மாநகராட்சி — சொத்து வரி மற்றும் தமிழ்நாடு அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("vellore"),
  },
  {
    slug: "thoothukudi",
    name: "Thoothukudi",
    nameTa: "தூத்துக்குடி",
    corp: true,
    desc: "Thoothukudi Municipal Corporation — official Tamil Nadu government payment links.",
    descTa: "தூத்துக்குடி மாநகராட்சி — அதிகாரப்பூர்வ அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("thoothukudi", "tuticorin", "toothukudi"),
  },
  {
    slug: "dindigul",
    name: "Dindigul",
    nameTa: "திண்டுக்கல்",
    corp: true,
    desc: "Dindigul Municipal Corporation — property tax and TN government payment links.",
    descTa: "திண்டுக்கல் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("dindigul"),
  },
  {
    slug: "thanjavur",
    name: "Thanjavur",
    nameTa: "தஞ்சாவூர்",
    corp: true,
    desc: "Thanjavur Municipal Corporation — property tax and official government payment links.",
    descTa: "தஞ்சாவூர் மாநகராட்சி — சொத்து வரி மற்றும் அதிகாரப்பூர்வ கட்டண இணைப்புகள்.",
    match: corpMatch("thanjavur", "tanjore"),
  },
  {
    slug: "hosur",
    name: "Hosur",
    nameTa: "ஓசூர்",
    corp: true,
    desc: "Hosur Municipal Corporation — property tax and Krishnagiri region TN payment links.",
    descTa: "ஓசூர் மாநகராட்சி — சொத்து வரி மற்றும் தமிழ்நாடு அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("hosur", "krishnagiri"),
  },
  {
    slug: "nagercoil",
    name: "Nagercoil",
    nameTa: "நாகர்கோவில்",
    corp: true,
    desc: "Nagercoil Municipal Corporation — Kanyakumari district government payment links.",
    descTa: "நாகர்கோவில் மாநகராட்சி — கன்னியாகுமரி மாவட்ட அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("nagercoil", "nagarcoil", "kanyakumari"),
  },
  {
    slug: "avadi",
    name: "Avadi",
    nameTa: "ஆவடி",
    corp: true,
    desc: "Avadi Municipal Corporation — Chennai region property tax and TN payment portals.",
    descTa: "ஆவடி மாநகராட்சி — சொத்து வரி மற்றும் தமிழ்நாடு அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("avadi"),
  },
  {
    slug: "cuddalore",
    name: "Cuddalore",
    nameTa: "கடலூர்",
    corp: true,
    desc: "Cuddalore Municipal Corporation — property tax and official TN government payment links.",
    descTa: "கடலூர் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("cuddalore"),
  },
  {
    slug: "kanchipuram",
    name: "Kanchipuram",
    nameTa: "காஞ்சிப்புரம்",
    corp: true,
    desc: "Kanchipuram Municipal Corporation — property tax and Tamil Nadu payment portals.",
    descTa: "காஞ்சிப்புரம் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("kanchipuram", "kancheepuram"),
  },
  {
    slug: "karur",
    name: "Karur",
    nameTa: "கரூர்",
    corp: true,
    desc: "Karur Municipal Corporation — property tax and official TN government payment links.",
    descTa: "கரூர் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("karur"),
  },
  {
    slug: "sivakasi",
    name: "Sivakasi",
    nameTa: "சிவகாசி",
    corp: true,
    desc: "Sivakasi Municipal Corporation — property tax and Virudhunagar region payment links.",
    descTa: "சிவகாசி மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("sivakasi", "virudhunagar"),
  },
  {
    slug: "tambaram",
    name: "Tambaram",
    nameTa: "தாம்பரம்",
    corp: true,
    desc: "Tambaram Municipal Corporation — Chengalpattu region property tax and TN payment links.",
    descTa: "தாம்பரம் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("tambaram", "chengalpattu"),
  },
  {
    slug: "kumbakonam",
    name: "Kumbakonam",
    nameTa: "கும்பகோணம்",
    corp: true,
    desc: "Kumbakonam Municipal Corporation — Thanjavur district government payment links.",
    descTa: "கும்பகோணம் மாநகராட்சி — அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("kumbakonam"),
  },
  {
    slug: "karaikudi",
    name: "Karaikudi",
    nameTa: "காரைக்குடி",
    corp: true,
    desc: "Karaikudi Municipal Corporation — Sivaganga district property tax and TN payment portals.",
    descTa: "காரைக்குடி மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("karaikudi", "sivaganga"),
  },
  {
    slug: "namakkal",
    name: "Namakkal",
    nameTa: "நாமக்கல்",
    corp: true,
    desc: "Namakkal Municipal Corporation — property tax and official Tamil Nadu payment links.",
    descTa: "நாமக்கல் மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("namakkal"),
  },
  {
    slug: "pudukkottai",
    name: "Pudukkottai",
    nameTa: "புதுக்கோட்டை",
    corp: true,
    desc: "Pudukkottai Municipal Corporation — property tax and TN government payment portals.",
    descTa: "புதுக்கோட்டை மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("pudukkottai", "pudukottai"),
  },
  {
    slug: "tiruvannamalai",
    name: "Tiruvannamalai",
    nameTa: "திருவண்ணாமலை",
    corp: true,
    desc: "Tiruvannamalai Municipal Corporation — property tax and official TN payment links.",
    descTa: "திருவண்ணாமலை மாநகராட்சி — சொத்து வரி மற்றும் அரசு கட்டண இணைப்புகள்.",
    match: corpMatch("tiruvannamalai", "thiruvannamalai"),
  },
  {
    slug: "tamil-nadu",
    name: "Tamil Nadu",
    nameTa: "தமிழ்நாடு",
    corp: false,
    desc: "All official Tamil Nadu government payment links — 37 departments, 130+ portals.",
    descTa: "அனைத்து அதிகாரப்பூர்வ தமிழ்நாடு அரசு கட்டண இணைப்புகள் — 37 துறைகள்.",
    match: () => true,
  },
];

export const CORPORATIONS = CITIES.filter((c) => c.corp);

const FEATURED_CORP_SLUGS = ["chennai", "coimbatore", "madurai", "trichy", "salem", "tirunelveli"];

export const FEATURED_CORPORATIONS = FEATURED_CORP_SLUGS.map((slug) =>
  CITIES.find((c) => c.slug === slug)
).filter(Boolean);

export function cityChipLabel(city, lang) {
  const star = city.featuredStar ? " ⭐" : "";
  if (lang === "ta") return `${city.nameTa} மாநகராட்சி (${city.name})${star}`;
  return `${city.name}${star}`;
}

function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 72);
}

export function paymentSlug(deptId, index, name) {
  return `${deptId}-${slugify(name)}-${index + 1}`;
}

export function allPaymentEntries() {
  return departments.flatMap((d) =>
    d.payments.map((p, index) => ({
      dept: d,
      payment: p,
      index,
      slug: paymentSlug(d.id, index, p.name),
      ta: DATA_TA[d.id]?.payments?.[index],
    }))
  );
}

export function getPaymentBySlug(slug) {
  return allPaymentEntries().find((e) => e.slug === slug) || null;
}

export function getCityBySlug(slug) {
  return CITIES.find((c) => c.slug === slug) || null;
}

export function cityPayments(city) {
  const items = allPaymentEntries();
  if (city.slug === "tamil-nadu") {
    return items.filter(({ payment }) => cityPaymentEligible(payment)).slice(0, 24);
  }
  const matched = items.filter(({ payment, dept }) => city.match(payment, dept));
  const eligible = matched.filter(({ payment }) => cityPaymentEligible(payment));
  if (eligible.length > 0) return eligible;
  if (city.corp) {
    const fallback = corpFallbackEntry(city);
    if (fallback) return [fallback];
  }
  return eligible;
}

export function guideTitle(entry, lang = "en") {
  const slug = entry.slug;
  if (slug === "1-electricity-bill-lt-1") {
    if (lang === "ta") return "TNEB / TNPDCL மின்சார கட்டணம் — ஆன்லைனில் எப்படி செலுத்துவது (2026)";
    return "TNEB / TNPDCL electricity bill pay online in Tamil Nadu (2026)";
  }
  if (slug === "2-chennai-property-tax-2" || slug === "2-tn-urban-municipal-tax-3") {
    if (lang === "ta") return "சொத்து வரி (Sotthu Vari) — ஆன்லைனில் எப்படி செலுத்துவது (2026)";
    return "Property tax (Sotthu Vari) pay online in Tamil Nadu (2026)";
  }
  const name = lang === "ta" && entry.ta?.name ? entry.ta.name : entry.payment.name;
  if (lang === "ta") return `${name} — ஆன்லைனில் எப்படி செலுத்துவது (2026)`;
  return `How to pay ${entry.payment.name} online in Tamil Nadu (2026)`;
}

export function guideDescription(entry, lang = "en") {
  const portal = entry.payment.portal;
  const dept = lang === "ta" && DATA_TA[entry.dept.id]?.dept
    ? DATA_TA[entry.dept.id].dept
    : entry.dept.dept;
  if (lang === "ta") {
    return `${dept} — ${entry.payment.name}. அதிகாரப்பூர்வ ${portal} தளம். IndiaFees பணம் வசூலிக்காது.`;
  }
  return `Pay ${entry.payment.name} via official ${portal} portal. ${dept}. IndiaFees is a free directory — we never collect money.`;
}

export function guideSteps(entry, lang = "en") {
  const portal = entry.payment.portal;
  const url = entry.payment.url;
  const slug = entry.slug;

  if (slug === "1-electricity-bill-lt-1") {
    if (lang === "ta") {
      return [
        "அதிகாரப்பூர்வ TNEBNET / TNPDCL தளத்தைத் திறக்கவும் (கீழே உள்ள இணைப்பு).",
        "Quick Pay தேர்ந்தெடுத்து consumer எண்ணை உள்ளிடவும்.",
        "UPI, கார்டு அல்லது நெட் பேங்கking மூலம் செலுத்தவும்.",
        "மாற்று: Google Pay / PhonePe → Bills → Tamil Nadu Electricity (TNEB).",
        "மாற்று: WhatsApp Namma Arasu +91 7845252525 → மின்சார கட்டணம்.",
        `அதிகாரப்பூர்வ URL: ${url}`,
      ];
    }
    return [
      "Open the official TNEBNET / TNPDCL portal (link below).",
      "Choose Quick Pay and enter your consumer number.",
      "Pay via UPI, card, or net banking on the government site.",
      "Alternative: Google Pay / PhonePe → Bills → Tamil Nadu Electricity (TNEB).",
      "Alternative: WhatsApp Namma Arasu +91 7845252525 → electricity bill payment.",
      `Official URL: ${url}`,
    ];
  }

  if (lang === "ta") {
    return [
      `IndiaFees-ல் "${entry.ta?.name || entry.payment.name}" க்கான அதிகாரப்பூர்வ இணைப்பைத் திறக்கவும்.`,
      `${portal} அரசுத் தளத்தில் consumer எண் / கணக்கு எண்ணை உள்ளிடவும்.`,
      "பில் தொகை மற்றும் விவரங்களை அரசுத் தளத்தில் சரிபார்க்கவும்.",
      "UPI, டெபிட் கார்டு அல்லது நெட் பேங்கking மூலம் அதிகாரப்பூர்வ தளத்தில் செலுத்தவும்.",
      "அரசுத் தளத்திலிருந்து ரசீதைப் பதிவிறக்கம் செய்து சேமிக்கவும்.",
      `அதிகாரப்பூர்வ URL: ${url}`,
    ];
  }
  return [
    `Open the official payment link for "${entry.payment.name}" on IndiaFees.`,
    `On the ${portal} government website, sign in or enter your consumer / account number.`,
    "Verify the bill amount and details on the official portal — not on IndiaFees.",
    "Pay using UPI, debit card, credit card, or net banking on the government site.",
    "Download and save the receipt from the official portal.",
    `Official URL: ${url}`,
  ];
}

export function guideFaqs(entry, lang = "en") {
  const url = entry.payment.url;
  const portal = entry.payment.portal;
  const isPropertyTax = /property-tax|municipal-tax/i.test(entry.slug);
  const extraEn = isPropertyTax
    ? [{ q: "When is property tax due in Tamil Nadu?", a: "Half-yearly: due Sep 30 (Apr–Sep) and Mar 31 (Oct–Mar). Pay within first 30 days of each half for 5% discount (max ₹5,000)." }]
    : [];
  const extraTa = isPropertyTax
    ? [{ q: "சொத்து வரி கடைசி தேதி என்ன?", a: "அரையாண்டுக்கு ஒருமுறை: செப் 30 மற்றும் மார்ச் 31. முதல் 30 நாட்களில் செலுத்தினால் 5% தள்ளுபடி (அதிகபட்சம் ₹5,000)." }]
    : [];
  if (lang === "ta") {
    return [
      {
        q: "IndiaFees அரசு வலைத்தளமா?",
        a: "இல்லை. IndiaFees சுயாதீன அடைவு. பணம் அதிகாரப்பூர்வ அரசுத் தளங்களில் மட்டுமே செலுத்தப்படும்.",
      },
      {
        q: `${entry.payment.name} எங்கே செலுத்துவது?`,
        a: `அதிகாரப்பூர்வ ${portal} தளம்: ${url}`,
      },
      {
        q: "IndiaFees இலவசமா?",
        a: "ஆம். IndiaFees இலவச அடைவு — நாங்கள் பணம் வசூலிக்க மாட்டோம்.",
      },
      {
        q: "பணம் செலுத்தும்போது என்ன சரிபார்க்க வேண்டும்?",
        a: "URL அரசு domain (.gov.in) என்பதையும், SSL பூட்டு (https) உள்ளதையும் சரிபார்க்கவும்.",
      },
      ...extraTa,
    ];
  }
  return [
    {
      q: "Is IndiaFees an official government website?",
      a: "No. IndiaFees is an independent directory. Payments are made only on official government portals.",
    },
    {
      q: `Where do I pay ${entry.payment.name}?`,
      a: `Use the official ${portal} portal: ${url}`,
    },
    {
      q: "Is IndiaFees free?",
      a: "Yes. IndiaFees is a free link directory. We never collect money or payment details.",
    },
    {
      q: "What should I verify before paying?",
      a: "Check the URL is a government domain (.gov.in or authorised portal) and the site uses HTTPS.",
    },
    ...extraEn,
  ];
}

export function buildFaqJsonLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function buildBreadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: item.url ? `${SITE_URL}${item.url}` : undefined,
    })),
  };
}

export function buildWebPageJsonLd({ title, description, path }) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: `${SITE_URL}${path}`,
    isPartOf: { "@type": "WebSite", name: "IndiaFees", url: SITE_URL },
  };
}

export function allSeoPaths() {
  const paths = [{ path: "/", priority: "1.0", changefreq: "daily" }];
  paths.push({ path: "/guides", priority: "0.9", changefreq: "weekly" });

  for (const d of departments) {
    paths.push({ path: `/dept/${d.id}`, priority: "0.85", changefreq: "weekly" });
  }

  for (const entry of allPaymentEntries()) {
    paths.push({ path: `/pay/${entry.slug}`, priority: "0.8", changefreq: "monthly" });
  }

  for (const city of CITIES) {
    paths.push({ path: `/city/${city.slug}`, priority: "0.75", changefreq: "weekly" });
  }

  for (const page of ["privacy", "terms", "contact", "disclaimer", "hyperlinking"]) {
    paths.push({ path: `/legal/${page}`, priority: "0.3", changefreq: "yearly" });
  }

  return paths;
}
